import { onMounted, onUnmounted } from 'vue'

/**
 * 全局 Esc 关闭最上层弹窗(统一行为)。在 App.vue 调一次即可,无需每个弹窗单独接。
 *
 * 原理:本项目所有弹窗/浮层的遮罩都用 `@click.self="<close>"` 收口关闭。Esc 时找到
 * 当前在 DOM 里、z-index 最高的那层遮罩,合成一次「点遮罩自身」,从而复用每个弹窗
 * **自己的**关闭逻辑(含 submitting/imageBusy 守卫、imagesDirty 回传、confirm 的取消等)。
 *
 * - 停叠弹窗(如确认框浮在弹窗之上)只关栈顶(z-index 最高那层)。
 * - 与 SearchSelect 配合:它下拉打开时 Esc 会 stopPropagation,事件到不了 window,
 *   所以 Esc 先收下拉、再按一次才关弹窗。
 */

// 所有遮罩类名(都带 @click.self 关闭)。登录/欢迎门等沿用各自遮罩行为。
const BACKDROP_SELECTOR = [
  '.modal-mask',
  '.overlay',
  '.mask',
  '.picker-mask',
  '.overlay-confirm',
  '.banner-modal-mask',
  '.pay-modal-backdrop'
].join(',')

function zIndexOf(el: HTMLElement): number {
  const z = parseInt(getComputedStyle(el).zIndex, 10)
  return Number.isNaN(z) ? 0 : z
}

function onKeydown(e: KeyboardEvent) {
  if (e.key !== 'Escape') return
  const masks = Array.from(document.querySelectorAll<HTMLElement>(BACKDROP_SELECTOR)).filter(
    (el) => {
      const s = getComputedStyle(el)
      // 只算真正可见的(v-if 已移除关闭的;这里再挡掉 display:none / v-show 隐藏的)
      return s.display !== 'none' && s.visibility !== 'hidden' && el.offsetWidth > 0
    }
  )
  if (masks.length === 0) return
  // 栈顶 = z-index 最高;同 z-index 取 DOM 中靠后的(后开的在后)
  let top = masks[0]
  for (const el of masks) {
    if (zIndexOf(el) >= zIndexOf(top)) top = el
  }
  top.click() // 触发遮罩 @click.self="<close>",走弹窗自己的关闭逻辑
}

export function useGlobalModalEscape() {
  onMounted(() => window.addEventListener('keydown', onKeydown))
  onUnmounted(() => window.removeEventListener('keydown', onKeydown))
}
